import React, {useEffect, useState} from 'react'
import PlayIcon from '../../assets/icons/playIcon'
import DownloadIcon from '../../assets/icons/downloadIcon'
import {useLocation, useParams} from 'react-router-dom';
import TopicCheckIcon from "../../assets/icons/topicCheckIcon";
import TopicUncheckIcon from "../../assets/icons/topicUncheckIcon";
import api from "../../services/api";
import PauseIcon from "../../assets/icons/pauseIcon";
import FileIcon from "../../assets/icons/fileIcon";


const Topic = ({time, name, onClick, id,index, isWatched, resourses, setCompletedTopicCount, completedTopicCount}) => {
    const {course, section, topic} = useParams();
    const location = useLocation();
    const [isChecked, setIsChecked] = useState(false);
    const [isPlay, setIsPlay] = useState(false)



    useEffect(() => {
        if (id == parseInt(topic)) {
            setIsPlay(true)
        }else{
            setIsPlay(false)
        }

        if(!topic && index === 0){
            setIsPlay(true)
        }
    }, [location])

    return (
        <div

            className='bg-dark-500 cursor-pointer'

            style={{
                display: "flex",
                gap: "13px",
                background: "#F6F6F9",
                alignItems: "center",
                padding: "9px 20px",
                borderRadius: "12px",
                justifyContent: "space-between"

            }}
        >
            <div
                className='d-flex a-i-center g-10'
            >

                <div
                    onClick={onClick}
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                        width: "-webkit-fill-available"

                    }}
                >
                    <p
                        className='text-white'
                        style={{
                            margin: "0",
                            fontFamily: "medium",
                            fontSize: "13px"
                        }}
                    >{name ? name : "No Topic"}</p>
                    <div
                        style={{
                            display: "flex",
                            gap: "7px",
                            alignItems: "center",

                        }}
                    >
                        <p
                            className='text-gray-100'
                            style={{
                                margin: "0px",
                                fontFamily: "semiBold",
                                fontSize: "12px",
                                color: "#BBBBBB"
                            }}
                        >{time ? ((time / 60).toFixed(2)) + " mins" : "00:00"}</p>

                    </div>
                </div>
            </div>
            <div
                style={{
                    width: "55px",
                    gap: "7px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end"
                }}
            >

                {
                    true
                        ?
                        <></>
                        :
                        <FileIcon
                            onClick={ null}
                            style={{
                                width: "24px",
                                height: "24px"
                            }}
                        />
                }
                {
                    isPlay
                        ?
                        <PauseIcon
                            style={{
                                width: "24px",
                                height: "24px"
                            }}
                        />
                        :
                        <PlayIcon
                            style={{
                                width: "24px",
                                height: "24px"
                            }}
                            onClick={() => onClick ? onClick() : null}/>
                }

            </div>
        </div>
    )
}

export default Topic
